export const notFoundTranslations = {
  en: {
    'notFound.pageTitle': 'Page Not Found',
    'notFound.error': 'Error 404',
    'notFound.message': "The page you're looking for doesn't exist or has been moved.",
    'notFound.requestedPath': 'Requested path:',
    'notFound.returnHome': 'Return to Home',
    'notFound.goBack': 'Go Back',
    'notFound.quickNav': 'Quick Navigation:',
    'notFound.nav.home': 'Home Dashboard',
    'notFound.nav.profile': 'Profile',
    'notFound.nav.contacts': 'Contacts',
    'notFound.nav.transactions': 'Transaction History',
    'notFound.nav.help': 'Help & Support',
    'notFound.help.title': 'Need help?',
    'notFound.help.message': 'Our support team is here to assist you.',
    'notFound.help.button': 'Visit Help Center',
  },
  es: {
    'notFound.pageTitle': 'Página No Encontrada',
    'notFound.error': 'Error 404',
    'notFound.message': 'La página que buscas no existe o ha sido movida.',
    'notFound.requestedPath': 'Ruta solicitada:',
    'notFound.returnHome': 'Volver al Inicio',
    'notFound.goBack': 'Regresar',
    'notFound.quickNav': 'Navegación Rápida:',
    'notFound.nav.home': 'Panel de Inicio',
    'notFound.nav.profile': 'Perfil',
    'notFound.nav.contacts': 'Contactos',
    'notFound.nav.transactions': 'Historial de Transacciones',
    'notFound.nav.help': 'Ayuda y Soporte',
    'notFound.help.title': '¿Necesitas ayuda?',
    'notFound.help.message': 'Nuestro equipo de soporte está aquí para ayudarte.',
    'notFound.help.button': 'Visitar Centro de Ayuda',
  },
  fr: {
    'notFound.pageTitle': 'Page introuvable',
    'notFound.error': 'Erreur 404',
    'notFound.message': 'La page que vous recherchez n\'existe pas ou a été déplacée.',
    'notFound.requestedPath': 'Chemin demandé :',
    'notFound.returnHome': 'Retour à l\'accueil',
    'notFound.goBack': 'Retour',
    'notFound.quickNav': 'Navigation rapide :',
    'notFound.nav.home': 'Tableau de bord',
    'notFound.nav.profile': 'Profil',
    'notFound.nav.contacts': 'Contacts',
    'notFound.nav.transactions': 'Historique des transactions',
    'notFound.nav.help': 'Aide et support',
    'notFound.help.title': 'Besoin d\'aide ?',
    'notFound.help.message': 'Notre équipe de support est là pour vous aider.',
    'notFound.help.button': 'Visiter le centre d\'aide',
  },
  sq: {
    'notFound.pageTitle': 'Faqja Nuk U Gjet',
    'notFound.error': 'Gabim 404',
    'notFound.message': 'Faqja që po kërkoni nuk ekziston ose është zhvendosur.',
    'notFound.requestedPath': 'Rruga e kërkuar:',
    'notFound.returnHome': 'Kthehu në Shtëpi',
    'notFound.goBack': 'Kthehu',
    'notFound.quickNav': 'Navigim i Shpejtë:',
    'notFound.nav.home': 'Paneli i Shtëpisë',
    'notFound.nav.profile': 'Profili',
    'notFound.nav.contacts': 'Kontaktet',
    'notFound.nav.transactions': 'Historia e Transaksioneve',
    'notFound.nav.help': 'Ndihmë & Mbështetje',
    'notFound.help.title': 'Keni nevojë për ndihmë?',
    'notFound.help.message': 'Ekipi ynë i mbështetjes është këtu për t\'ju ndihmuar.',
    'notFound.help.button': 'Vizitoni Qendrën e Ndihmës',
  },
  ru: {
    'notFound.pageTitle': 'Страница не найдена',
    'notFound.error': 'Ошибка 404',
    'notFound.message': 'Запрашиваемая страница не существует или была перемещена.',
    'notFound.requestedPath': 'Запрошенный путь:',
    'notFound.returnHome': 'Вернуться на главную',
    'notFound.goBack': 'Назад',
    'notFound.quickNav': 'Быстрая навигация:',
    'notFound.nav.home': 'Главная панель',
    'notFound.nav.profile': 'Профиль',
    'notFound.nav.contacts': 'Контакты',
    'notFound.nav.transactions': 'История транзакций',
    'notFound.nav.help': 'Помощь и поддержка',
    'notFound.help.title': 'Нужна помощь?',
    'notFound.help.message': 'Наша команда поддержки готова помочь вам.',
    'notFound.help.button': 'Посетить центр помощи',
  },

  de: {
    'notFound.pageTitle': 'Seite nicht gefunden',
    'notFound.error': 'Fehler 404',
    'notFound.message': 'Die gesuchte Seite existiert nicht oder wurde verschoben.',
    'notFound.requestedPath': 'Angeforderter Pfad:',
    'notFound.returnHome': 'Zurück zur Startseite',
    'notFound.goBack': 'Zurück',
    'notFound.quickNav': 'Schnellnavigation:',
    'notFound.nav.home': 'Start-Dashboard',
    'notFound.nav.profile': 'Profil',
    'notFound.nav.contacts': 'Kontakte',
    'notFound.nav.transactions': 'Transaktionsverlauf',
    'notFound.nav.help': 'Hilfe & Support',
    'notFound.help.title': 'Benötigen Sie Hilfe?',
    'notFound.help.message': 'Unser Support-Team ist hier, um Ihnen zu helfen.',
    'notFound.help.button': 'Hilfezentrum besuchen',
  },

  sr: {
    'notFound.pageTitle': 'Страница није пронађена',
    'notFound.error': 'Грешка 404',
    'notFound.message': 'Страница коју тражите не постоји или је премештена.',
    'notFound.requestedPath': 'Захтевана путања:',
    'notFound.returnHome': 'Повратак на почетну',
    'notFound.goBack': 'Врати се',
    'notFound.quickNav': 'Брза навигација:',
    'notFound.nav.home': 'Контролна табла',
    'notFound.nav.profile': 'Профил',
    'notFound.nav.contacts': 'Контакти',
    'notFound.nav.transactions': 'Историја трансакција',
    'notFound.nav.help': 'Помоћ и подршка',
    'notFound.help.title': 'Треба вам помоћ?',
    'notFound.help.message': 'Наш тим за подршку је ту да вам помогне.',
    'notFound.help.button': 'Посетите центар за помоћ',
  },
  pl: {
    'notFound.pageTitle': 'Strona Nie Znaleziona',
    'notFound.error': 'Błąd 404',
    'notFound.message': 'Strona, której szukasz, nie istnieje lub została przeniesiona.',
    'notFound.requestedPath': 'Żądana ścieżka:',
    'notFound.returnHome': 'Powrót do Strony Głównej',
    'notFound.goBack': 'Wstecz',
    'notFound.quickNav': 'Szybka Nawigacja:',
    'notFound.nav.home': 'Panel Główny',
    'notFound.nav.profile': 'Profil',
    'notFound.nav.contacts': 'Kontakty',
    'notFound.nav.transactions': 'Historia Transakcji',
    'notFound.nav.help': 'Pomoc i Wsparcie',
    'notFound.help.title': 'Potrzebujesz pomocy?',
    'notFound.help.message': 'Nasz zespół wsparcia jest tutaj, aby Ci pomóc.',
    'notFound.help.button': 'Odwiedź Centrum Pomocy',
  },
  el: {
    'notFound.pageTitle': 'Η Σελίδα Δεν Βρέθηκε',
    'notFound.error': 'Σφάλμα 404',
    'notFound.message': 'Η σελίδα που αναζητάτε δεν υπάρχει ή έχει μετακινηθεί.',
    'notFound.requestedPath': 'Ζητούμενη διαδρομή:',
    'notFound.returnHome': 'Επιστροφή στην Αρχική',
    'notFound.goBack': 'Πίσω',
    'notFound.quickNav': 'Γρήγορη Πλοήγηση:',
    'notFound.nav.home': 'Πίνακας Αρχικής',
    'notFound.nav.profile': 'Προφίλ',
    'notFound.nav.contacts': 'Επαφές',
    'notFound.nav.transactions': 'Ιστορικό Συναλλαγών',
    'notFound.nav.help': 'Βοήθεια & Υποστήριξη',
    'notFound.help.title': 'Χρειάζεστε βοήθεια;',
    'notFound.help.message': 'Η ομάδα υποστήριξής μας είναι εδώ για να σας βοηθήσει.',
    'notFound.help.button': 'Επισκεφτείτε το Κέντρο Βοήθειας',
  },
  ro: {
    'notFound.pageTitle': 'Pagina Nu a Fost Găsită',
    'notFound.error': 'Eroare 404',
    'notFound.message': 'Pagina pe care o căutați nu există sau a fost mutată.',
    'notFound.requestedPath': 'Calea solicitată:',
    'notFound.returnHome': 'Înapoi la Pagina Principală',
    'notFound.goBack': 'Înapoi',
    'notFound.quickNav': 'Navigare Rapidă:',
    'notFound.nav.home': 'Tablou de Bord Principal',
    'notFound.nav.profile': 'Profil',
    'notFound.nav.contacts': 'Contacte',
    'notFound.nav.transactions': 'Istoric Tranzacții',
    'notFound.nav.help': 'Ajutor & Suport',
    'notFound.help.title': 'Aveți nevoie de ajutor?',
    'notFound.help.message': 'Echipa noastră de suport este aici pentru a vă ajuta.',
    'notFound.help.button': 'Vizitați Centrul de Ajutor',
  },
  pt: {
    'notFound.pageTitle': 'Página Não Encontrada',
    'notFound.error': 'Erro 404',
    'notFound.message': 'A página que você está procurando não existe ou foi movida.',
    'notFound.requestedPath': 'Caminho solicitado:',
    'notFound.returnHome': 'Voltar para Início',
    'notFound.goBack': 'Voltar',
    'notFound.quickNav': 'Navegação Rápida:',
    'notFound.nav.home': 'Painel Principal',
    'notFound.nav.profile': 'Perfil',
    'notFound.nav.contacts': 'Contatos',
    'notFound.nav.transactions': 'Histórico de Transações',
    'notFound.nav.help': 'Ajuda e Suporte',
    'notFound.help.title': 'Precisa de ajuda?',
    'notFound.help.message': 'Nossa equipe de suporte está aqui para ajudá-lo.',
    'notFound.help.button': 'Visite o Centro de Ajuda',
  },
};
